<template>
  <div class="correct">
    <div class="title">
      <img src="@/assets/img/weekReport/corrent.png" alt="" />
      <h3>正确率分析</h3>
    </div>
    <div class="analysis weekreportAnalysis">
      <ul>
        <li v-html="fontTips()"></li>
      </ul>
    </div>
    <div class="line">
      <div id="correctRate"></div>
    </div>
    <div class="list">
      <ul>
        <li>
          <div>
            英语对比上周
            <img
              v-if="pingjunData[4]?.value - pingjunData[3]?.value != 0"
              :src="pingjunData[4]?.value - pingjunData[3]?.value > 0 ? compare_up : compare_down"
              alt=""
            />
          </div>
          <p>
            {{ pingjunData[4]?.value - pingjunData[3]?.value > 0 ? '+' : '' }}
            {{ (pingjunData[4]?.value - pingjunData[3]?.value).toFixed(2) + '%' }}
          </p>
        </li>
        <li>
          <div>
            数学对比上周
            <img
              v-if="pingjunData[1]?.value - pingjunData[0]?.value != 0"
              :src="pingjunData[1]?.value - pingjunData[0]?.value > 0 ? compare_up : compare_down"
              alt=""
            />
          </div>
          <p>
            {{ pingjunData[1]?.value - pingjunData[0]?.value > 0 ? '+' : '' }}
            {{ (pingjunData[1]?.value - pingjunData[0]?.value).toFixed(2) + '%' }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Bar } from '@antv/g2plot';
export default {
  props: {
    pingjunTitinfo: {
      type: Object,
      default: () => {},
    },
    pingjunData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      compare_up: require('@/assets/img/weekReport/compare_up.png'),
      compare_down: require('@/assets/img/weekReport/compare_down.png'),
    };
  },
  mounted() {},
  watch: {
    pingjunData(value) {
      if (value.length > 0) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      const data = this.pingjunData;
      const stackedBarPlot = new Bar('correctRate', {
        data,
        height: 240,
        isGroup: true,
        xField: 'value',
        yField: 'label',
        seriesField: 'type',
        marginRatio: 0,
        dodgePadding: 10,
        color: ['#4A77FF', '#FF7634', '#00DEAB'],
        appendPadding: [0, 20, 20, 0],
        barStyle: { radius: [10, 10, 10, 10] },
        minBarWidth: 16,
        maxBarWidth: 16,
        legend: {
          position: 'bottom',
          marker: {
            symbol: 'circle',
            style: (oldStyle) => {
            return {
              ...oldStyle,
              r: 6,
              // square marker 只有填充色，赋给 line 的 stroke
              stroke: oldStyle.stroke || oldStyle.fill,
            };
          },
          },
        },
        label: {
          offsetX: -10,
          position: 'right', // 'left', 'middle', 'right'
          content: (item) => {
            return item.value + '%';
          },
        },
        xAxis: {
          label: {
            style: {
              fill: '#999',
              fontSize: 12
            },
            formatter: (item, value) => {
              return  item + '%';
            },
          },
        },
        yAxis: {
          label: {
            visible: true,
            style: {
              fill: '#999',
            },
          },
        },
      });

      stackedBarPlot.render();
    },

    fontTips() {
      let ratioType = this.pingjunTitinfo.ratioType;
      let type = this.pingjunTitinfo.type;
      let averageCorrectRatio = this.pingjunTitinfo.averageCorrectRatio + '%';
      let improveSubjectName = this.pingjunTitinfo.improveSubjectName;
      let ultraCorrectRatio = this.pingjunTitinfo.ultraCorrectRatio + '%';

      let text = '';

      if (ratioType === 1 && type === 1) {
        text = `本周两学科综合正确率<span>${averageCorrectRatio} </span>，比全站平均正确率高<span>${ultraCorrectRatio} </span>。其中，<span> ${improveSubjectName}</span>学科低于该学科平均值，建议适当增加<span> ${improveSubjectName}</span>学科刷题量，能够提升正确率~`;
      } else if (ratioType === 1 && type === 2) {
        text = `本周单学科平均正确率<span>${averageCorrectRatio} </span>，比全站平均正确率低<span>${ultraCorrectRatio} </span>。其中，<span> ${improveSubjectName}</span>学科低于该学科平均值，建议适当增加<span> ${improveSubjectName}</span>学科刷题量，能够提升正确率~`;
      } else if (ratioType === 2) {
        text = `本周两学科综合正确率<span>${averageCorrectRatio} </span>，比全站平均正确率低<span>${ultraCorrectRatio} </span>。两门学科都没达到平均正确率，建议先通过听课掌握考点及解题方法，之后多做题，逐步提高！`;
      } else if (ratioType === 3) {
        text = `本周两学科综合正确率<span>${averageCorrectRatio} </span>，比全站平均正确率高<span>${ultraCorrectRatio} </span>。恭喜你，本周两门学科均超出了平均正确率，再接再厉，继续加油！`;
      } else if (ratioType === 4) {
        text = `本周两学科综合正确率<span>${averageCorrectRatio} </span>，等于全站平均正确率。恭喜你，本周你的学习成绩已达到平均值，再接再厉，继续加油！`;
      } else {
        text = ``;
      }

      return text;
    },
  },
};
</script>

<style scoped lang="scss">
.correct {
  position: relative;
  width: 678px;
  background: #ffffff;
  box-shadow: 0px 4 11px 0px rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  margin: 0 auto 20px;
  padding: 30px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    img {
      display: block;
      width: 30px;
      height: 30px;
      margin-right: 7px;
    }
    h3 {
      font-size: 29px;
      font-weight: 500;
      color: #333333;
    }
  }
  .analysis {
    ul {
      li {
        position: relative;
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
        padding-left: 26px;
        line-height: 34px;
        span {
          color: #ff3938;
        }
      }
    }
  }
  .line {
    margin: 30px auto;
  }
  .list {
    width: 612px;
    background: #f9f9f9;
    border-radius: 14px;
    margin: 0 auto;
    padding: 30px 0px;
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      li {
        position: relative;
        width: 50%;
        text-align: center;
        div {
          font-size: 25px;
          font-weight: 400;
          color: #999999;
          text-align: center;
          margin-bottom: 30px;
          img {
            display: inline-block;
            width: 30px;
            height: 30px;
            vertical-align: middle;
          }
        }
        p {
          font-size: 36px;
          font-weight: 500;
          color: #ff7f41;
        }
      }
      li:after {
        position: absolute;
        right:0px;
        top: 24px;
        display: block;
        content: '';
        width: 2px;
        height: 47px;
        background: #453c3c3d;
      }
      li:last-child:after {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
.weekreportAnalysis {
  span {
    color: #ff3938;
  }
}
</style>
